import { addDoc, collection, doc, getDocs, query, updateDoc, where, writeBatch } from 'firebase/firestore';
import { db } from './firebase';
import type { UserNotification, UserNotificationType } from '../types';

export interface CreateUserNotificationInput {
    readonly userId: string;
    readonly type: UserNotificationType;
    readonly title: string;
    readonly body: string;
    readonly recipeId?: string;
}

export async function createUserNotification(input: CreateUserNotificationInput): Promise<string> {
    const ref = await addDoc(collection(db, 'users', input.userId, 'notifications'), {
        type: input.type,
        title: input.title,
        body: input.body,
        ...(input.recipeId ? { recipeId: input.recipeId } : {}),
        read: false,
        createdAt: new Date().toISOString(),
    });
    return ref.id;
}

export async function markNotificationRead(userId: string, notificationId: string): Promise<void> {
    await updateDoc(doc(db, 'users', userId, 'notifications', notificationId), {
        read: true,
    });
}

export async function markAllNotificationsRead(userId: string): Promise<void> {
    const unreadQuery = query(
        collection(db, 'users', userId, 'notifications'),
        where('read', '==', false),
    );
    const snap = await getDocs(unreadQuery);
    if (snap.empty) return;

    const batch = writeBatch(db);
    snap.docs.forEach((notificationDoc) => {
        batch.update(notificationDoc.ref, { read: true });
    });
    await batch.commit();
}
